'use client'

import {observer} from 'mobx-react'
import React from 'react'

import {getInjection} from '@runlab/di'

import {PageTitleRenderFn} from '@/src/core/domain/page/functions/types'

import {useStore} from '@/src/shared/hooks/useStore'
import {usePageProps} from '@/src/shared/modules/page/page-content-provider'
import {LayoutMeta} from '@/src/shared/ui/layout/ui/meta'
import {LayoutUI} from '@/src/shared/ui/layout/ui/styles'
import {PageTitle as PageTitleComponent} from '@/src/shared/ui/layout/ui/page-title'

export const PageTitle = observer(() => {
  const store = useStore()
  const pagePropsStore = usePageProps()

  if (pagePropsStore.transformKey) {
    try {
      const HeadRenderComponent = getInjection('PageParamsFunctionsRegistry').get<PageTitleRenderFn>(
        pagePropsStore.transformKey,
        'pageTitle',
      )
      return <HeadRenderComponent />
    } catch (e: unknown) {
      // TODO: заменить эксепшеном из PageFunctionsRegistry
      if (e instanceof Error && e.message.includes('not registered')) {
        /***/
      } else {
        throw e
      }
    }
  }

  return (
    <LayoutUI.Meta
      as={LayoutMeta}
      title={
        (pagePropsStore.options?.title && (
          <PageTitleComponent>
            <h1>{pagePropsStore.options.title}</h1>
          </PageTitleComponent>
        )) ??
        undefined
      }
      breadcrumbs={(store.pageData?.breadcrumbs && store.pageData.breadcrumbs) ?? []}
    />
  )
})
